import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Inject, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { DocumentService } from '@app/shared/services';
import { CryptoService } from '@app/shared/services/crypto/crypto.services';
import { InboxSettingsService } from '@app/shared/services/settings/inbox-settings/inbox-settings.service';
import { ToastrService } from 'ngx-toastr';
import { Subscription } from 'rxjs';
import { InboxAttachmentListComponent } from './inbox-attachment-list/inbox-attachment-list.component';
import { MobileDeliveryListFileComponent } from './mobile-delivery-list-file/mobile-delivery-list-file.component';
import { SharedConfirmationDialogComponent } from '@app/shared/component/shared-confirmation-dialog/shared-confirmation-dialog.component';
import { FileTypeListSizeEnum, FileUploadedLimitExtension } from '@app/enum/FileTypeListSizeEnum';
import { TaskService } from '@app/shared/services/task/task.service';
import { ChecklistService } from '@app/shared/services/checklist/checklist.service';
import { ChecklistTaskService } from '@app/shared/services/checklist/checklist-task.service';
import { LoginStoreEffects } from '@app/root-store/login-store/effects';
import { AddSubfolderComponent } from '../../dialogs/add-subfolder/add-subfolder.component';
import JSZip from 'jszip';
import { AutoUnsubscribe } from '@app/shared/decorators/auto-unsubscribe.decorator';
@AutoUnsubscribe()
@Component({
  selector: 'create-attachemnt-popup',
  templateUrl: './create-attachemnt-popup.component.html',
  styleUrls: ['./create-attachemnt-popup.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CreateAttachemntPopupComponent implements OnInit, OnDestroy {
  @ViewChild(InboxAttachmentListComponent) inboxAttachmentList;
  @ViewChild(MobileDeliveryListFileComponent) mobileDeliveryListFile;

  new = false;
  files = [];
  allFiles = [];
  openInboxFiles = false;
  moveToBack = false;
  inboxFiles = [];
  openMobileDeliveryFile = false;
  active = false;
  currentFormId;
  showToggle = true;
  FileUploadedLimit = FileTypeListSizeEnum.FileUploadedLimit;
  FileUploadedLimitExtension = FileUploadedLimitExtension;

  openMobileDeliveryLink = false;
  fileCount = 0;
  origin;
  isSecurityKeyAdded;
  inboxFileAttached = false;

  enable_task = false;
  formUserPublicKey;
  sk;
  security_key;

  task_id;
  manageSecuritykey;
  currentWorkspaceOwner;
  userId;
  formEncryptionKey;
  subscription = new Subscription();
  generalSection: FormControl = new FormControl(false);
  securityStateObject;
  completedCount = 0;
  myForm = new FormGroup({
    name: new FormControl(false),
  });
  folderList = [];

  constructor(
    @Inject(MAT_DIALOG_DATA) public data,
    private toastr: ToastrService,
    public dialogRef: MatDialogRef<CreateAttachemntPopupComponent>,
    private documentService: DocumentService,
    private dialog: MatDialog,
    private _loginService: LoginStoreEffects,
    private _checklistTaskService: ChecklistTaskService,
    private _inboxService: InboxSettingsService,
    private cryptoService: CryptoService,
    private cd: ChangeDetectorRef
  ) {}
  ngOnDestroy(): void {
    this.subscription?.unsubscribe();
  }

  onDragStart(event) {
    this.cd.detectChanges();
  }
  onDrag(event) {
    this.cd.detectChanges();
  }
  onDragEnd(event) {
    this.cd.detectChanges();
  }
  async scanAndLogFiles(item) {
    // const newFile = item.event.dataTransfer.files;
    let newElt = item;

    if (item.isDirectory) {
      const promise = [];
      let directoryReader = item.createReader();
      directoryReader.readEntries((entries) => {
        entries.forEach(async (entry) => {
          try {
            // this.readFile(entry, null, null)
          } catch (error) {}

          this.scanAndLogFiles(entry);
        });
      });
    }

    if (item.isDirectory) {
      newElt.originalFile = undefined;
      this.data.folderList.push(newElt);
    } else {
      item.file((file) => {
        this.uploadFile([file]);
      });
    }
  }

  async dragged(event) {
    this.folderList = [];
    const items = event.dataTransfer.items;
    const fileLists = event.dataTransfer.files;
    this.data = {
      items,
      fileLists,
      folderList: this.folderList,
    };
    this.cd.detectChanges();
    for (let i = 0; i < items.length; i++) {
      let item = items[i].webkitGetAsEntry();
      let fileList = fileLists[i];
      item.size = fileList.size;
      item.type = fileList.type;
      item.completed = false;
      if (item) {
        this.scanAndLogFiles(item);
      }
    }
  }

  ngOnInit(): void {
    this.subscription.add(
      this._loginService.loginObject.subscribe((state) => {
        if (state && state.data && state.data.id) {
          this.userId = state.data.id;
        }
      })
    );
    this.manageSecuritykey = this.data.manageSecuritykey;
    this.isSecurityKeyAdded = this.data.isSecurityKeyAdded;
    this.formUserPublicKey = this.data.formUserPublicKey;
    this.myForm.controls.name.setValue(this.data.mark_complete ? this.data.mark_complete : false);
    this.origin = this.data.origin;
    this.sk = this.data.sk;
    this.security_key = this.data.security_key;
    this.currentFormId = this.data.currentFormId;
    this.formEncryptionKey = this.data.formEncryptionKey;

    this.currentWorkspaceOwner = this.data.currentWorkspaceOwner;
    this.new = this.data?.new ? this.data?.new : false;
    this.task_id = this.data?.task_id ? this.data?.task_id : false;

    this.enable_task = this.data?.sub_type === 'Task' ? true : false;
    if (this.data?.showToggle !== undefined && this.data?.showToggle !== null) {
      this.showToggle = this.data.showToggle;
    }
  }
  onChange() {
    this.closedialog();
  }
  myFunction(event) {
    this.cd.detectChanges();
  }

  uploadFile(event) {
    this.active = false;
    let counter = 0;
    for (let index = 0; index < event.length; index++) {
      const element = event[index];

      const fileSizeInKB = element.size / 1024;
      const fileSizeInMB = fileSizeInKB / 1024;
      const extension = element['name'].split('?')[0].split('.').pop();
      if (this.FileUploadedLimitExtension.findIndex((item) => item == extension.toUpperCase()) == -1) {
        this.moveToBack = true;
        this.files.push({
          name: element.name,
          status: 'fail',
          size: element.size,
          error_message: 'This is an unsupported file type',
          type: element.type,
          id: '',
          origin: 'mobile',
        });
        this.completedCount = this.completedCount + 1;
        this.cd.detectChanges();
      } else if (fileSizeInMB > this.FileUploadedLimit) {
        this.moveToBack = true;
        this.files.push({
          name: element.name,
          status: 'fail',
          size: element.size,
          error_message: 'This file exceeds the maximum size of ' + this.FileUploadedLimit + 'MB',
          type: element.type,
          id: '',
          origin: 'mobile',
        });
        this.completedCount = this.completedCount + 1;
        this.cd.detectChanges();
      } else if (element.type.includes('zip')) {
        this.unzipFile(element);
      } else {
        this.files.push({
          display_file_name: element.name,
          status: 'running',
          name: element.name,
          file_name_without_extesion:
            element.name.split('.').slice(0, -1).length == 0 ? element.name : element.name.split('.').slice(0, -1).join('.'),
          size: element.size,
          error_message: '',
          type: element.type,
          id: '',
          origin: 'mobile',
        });

        this.moveToBack = true;
        this.uploadfileToserver(element['name'], element['size'], element, element['type'], this.files.length - 1, counter++);
        this.cd.detectChanges();
      }
    }
  }
  unzipFile(file) {
    const reader = new FileReader();

    reader.onload = async (e: any) => {
      const arrayBuffer = e.target.result;
      const zip = await JSZip.loadAsync(arrayBuffer);

      zip.forEach(async (relativePath, fileEntry) => {
        if (!fileEntry.dir) {
          const fileContent = await fileEntry.async('blob'); // or 'text' / 'arraybuffer' as needed
          const fileNameOnly = relativePath.split('/').pop();
          const unzippedFile = new File([fileContent], fileNameOnly, { type: fileContent.type });
          if (unzippedFile.name.toLowerCase().includes('zip')) {
            this.unzipFile(unzippedFile);
          } else {
            this.files.push({
              display_file_name: unzippedFile.name,
              status: 'running',
              name: unzippedFile.name,
              file_name_without_extesion:
                unzippedFile.name.split('.').slice(0, -1).length == 0 ? unzippedFile.name : unzippedFile.name.split('.').slice(0, -1).join('.'),
              size: unzippedFile.size,
              error_message: '',
              type: unzippedFile.type,
              id: '',
              origin: 'mobile',
            });

            this.moveToBack = true;
            this.uploadfileToserver(unzippedFile['name'], unzippedFile['size'], unzippedFile, unzippedFile['type'], this.files.length - 1, -1);
          }
        }
      });

      this.cd.markForCheck();
    };

    reader.readAsArrayBuffer(file);
  }

  uploadfileToserver(fileName, size, file_data, type, index, currentIndex) {
    const data = {
      vault_user_form_id: this.currentFormId,

      user_id: this.userId,
      name: fileName,
      file_name_without_extesion: fileName.split('.').slice(0, -1).length == 0 ? fileName : fileName.split('.').slice(0, -1).join('.'),
      display_file_name: fileName,
      size: size,
      checklist_task_id: this.task_id,
      type: file_data.type,
    };
    if (this.enable_task) {
      this.subscription.add(
        this._checklistTaskService.createUploadUrl(data).subscribe(
          async (res) => {
            this.files[index].delete_id = res['id'];
            this.files[index].delete_upload_path = res['upload_path'];
            this.files[index].file_name_without_extesion =
              fileName.split('.').slice(0, -1).length == 0 ? fileName : fileName.split('.').slice(0, -1).join('.');
            this.files[index].display_file_name = fileName;

            this.moveToBack = true;

            const xhr = new XMLHttpRequest();
            xhr.open('PUT', res['upload_url'], true);
            xhr.setRequestHeader('Content-Type', file_data.type);
            xhr.send(file_data);
            xhr.onload = () => {
              if (xhr.readyState === xhr.DONE) {
                const data = {
                  id: this.files[index]['delete_id'],
                  status: 'uploaded',
                  encryption_key: null,
                  premium_encrypted: null,
                };
                this.subscription.add(
                  this._checklistTaskService.updateUploadStatus(data).subscribe(
                    (res) => {
                      this.files[index]['status'] = 'Done';

                      this.allFiles.push({
                        status: 'Done',
                        file_name_without_extesion:
                          fileName.split('.').slice(0, -1).length == 0 ? fileName : fileName.split('.').slice(0, -1).join('.'),
                        display_file_name: fileName,
                        name: fileName,
                        size: size,
                        created_at: res['created_at'],
                        delete_id: res['id'],
                        delete_upload_path: res['upload_path'],
                      });
                      this.fileCount++;
                      this.cd.detectChanges();
                    },
                    (error) => {
                      this.toastr.error('Error uploading File');
                    }
                  )
                );
                this.cd.detectChanges();
              }
            };
          },
          (error) => {}
        )
      );
    } else {
      this.subscription.add(
        this.documentService.postCreatePresignedUrl(data, false).subscribe(
          async (res) => {
            this.moveToBack = true;
            this.files[index].delete_id = res['id'];
            this.files[index].delete_upload_path = res['upload_path'];
            this.files[index].file_name_without_extesion =
              fileName.split('.').slice(0, -1).length == 0 ? fileName : fileName.split('.').slice(0, -1).join('.');
            this.files[index].display_file_name = fileName;

            const xhr = new XMLHttpRequest();

            // let usersPk;
            // //check to see if this form is part of a workspace, if so use workspace owner for file encryption work
            // if (this.origin == 'workspace') {
            //   usersPk = this.currentWorkspaceOwner.public_key;
            // } else {
            //   usersPk = this.public_key();
            // }

            // if (!this.formEncryptionKey) {
            //   //ensure we have a form encyprtion key incase a file is attached before the first form save
            //   this.formEncryptionKey = this.cryptoService.generateEncryptionKey(usersPk, null, null).plain;
            // }

            // let encryptedFile;
            // if (this.isSecurityKeyAdded && this.manageSecuritykey != null && this.manageSecuritykey[0]['sk']) {
            //   //encrypt file before sending it to the server
            //   encryptedFile = await this.cryptoService.encryptFile(file_data, this.public_key(), this.formEncryptionKey, this.security_key, this.sk);
            // } else {
            //   //encrypt file before sending it to the server
            //   encryptedFile = await this.cryptoService.encryptFile(file_data, usersPk, this.formEncryptionKey, null, null);
            // }

            xhr.open('PUT', res['upload_url'], true);
            xhr.setRequestHeader('Content-Type', file_data.type);
            xhr.send(file_data);
            xhr.onload = () => {
              if (xhr.readyState === xhr.DONE) {
                const data = {
                  id: this.files[index]['delete_id'],
                  status: 'uploaded',
                  encryption_key: null,
                  premium_encrypted: null,
                };
                this.subscription.add(
                  this.documentService.setFileuploadedStatus(data).subscribe(
                    (res) => {
                      this.files[index]['status'] = 'Done';
                      this.allFiles.push({
                        status: 'Done',
                        file_name_without_extesion:
                          fileName.split('.').slice(0, -1).length == 0 ? fileName : fileName.split('.').slice(0, -1).join('.'),
                        display_file_name: fileName,
                        name: fileName,
                        size: size,
                        created_at: res['created_at'],
                        delete_id: res['id'],
                        delete_upload_path: res['upload_path'],
                      });
                      this.fileCount++;
                      this.cd.detectChanges();
                    },
                    (error) => {
                      this.toastr.error('Error uploading File');
                    }
                  )
                );
                this.cd.detectChanges();
              }
            };
          },
          (error) => {}
        )
      );
    }
  }

  getFileExtension(filePath) {
    // Use the `split` method to break the path into an array using the '.' separator
    const parts = filePath.split('.');

    // The last part of the array will be the file extension
    const extension = '.' + parts[parts.length - 1];

    return extension;
  }

  renameFile(element, index) {
    const dialogRef = this.dialog.open(AddSubfolderComponent, {
      width: '400px',
      data: {
        title: 'Rename',
        buttonName: 'Rename',
        currentFolderName: element.name.split('.').slice(0, -1).length == 0 ? element.name : element.name.split('.').slice(0, -1).join('.'),
      },
    });

    this.subscription.add(
      dialogRef.afterClosed().subscribe((data) => {
        if (data && data.confirmation) {
          let model = {
            user_id: this.userId,
            id: element.delete_id,
            custom_folder_name: data?.subfolderName + this.getFileExtension(element.name),
          };

          this.subscription.add(
            this._inboxService.updateInboxAttachmentFileName(model).subscribe((res) => {
              if (res.status == 200) {
                this.files[index].name = data?.subfolderName + this.getFileExtension(element.name);
                this.cd.detectChanges();
              }
            })
          );
        }
      })
    );
  }
  deleteFile(file, i) {
    // only splice array when item is found

    this.deleteEventHandler(file.delete_id, i);
  }
  deleteEventHandler(id, i) {
    let attachmentFilesIds: number[] = [id];
    const dialogRef = this.dialog.open(SharedConfirmationDialogComponent, {
      width: '400px',
      data: {
        title: 'Delete Attachment',
        materialIcon: 'delete',
        text: `Deleting this attachment is permanent and cannot be undone.`,
        proceedTitle: 'Delete',
      },
    });
    this.subscription.add(
      dialogRef.afterClosed().subscribe((confirmation) => {
        if (confirmation?.confirmation) {
          this.subscription.add(
            this._inboxService.deleteInboxAttachments(attachmentFilesIds, this.userId).subscribe(
              (result: any) => {
                this.files.splice(i, 1); // 2nd parameter means remove one item only
                if (result.status == 200) {
                  this.toastr.success(`file deleted successfully`);
                  this.completedCount = this.completedCount - 1;
                  this.cd.detectChanges();
                }
              },
              (error: any) => {}
            )
          );
        }
      })
    );
  }

  drop(ev) {
    this.cd.detectChanges();
  }

  // public_key() {
  //   if (this.formUserPublicKey) {
  //     return this.formUserPublicKey;
  //   } else {
  //     return this.securityStateObject.public_key;
  //   }
  // }

  dropleave(ev) {
    this.active = false;
    this.cd.detectChanges();
  }
  saveInboxAttachment(attachmentIds) {
    if (this.enable_task) {
      this.subscription.add(
        this._inboxService.attachToInboxTask(attachmentIds, this.userId, this.task_id).subscribe(
          (result: any) => {
            this.inboxFileAttached = true;
            let vault_user_form_uploads_id = [];
            try {
              vault_user_form_uploads_id = this.allFiles.map((x) => x.delete_id);
              vault_user_form_uploads_id = vault_user_form_uploads_id.concat(result.data.vault_user_form_uploads_id);
            } catch (error) {}
            if (result?.data.status == 'success') {
              this.dialogRef.close({
                isSuccess: true,
                files: this.allFiles,
                isRefresh: true,
                mark_complete: this.myForm.value.name,
                vault_user_form_uploads_id: vault_user_form_uploads_id,
              });
            }
          },
          (error: any) => {}
        )
      );
    } else {
      this.subscription.add(
        this._inboxService.attachToInbox(attachmentIds, this.userId, this.currentFormId).subscribe(
          (result: any) => {
            this.inboxFileAttached = true;
            let vault_user_form_uploads_id = [];
            try {
              vault_user_form_uploads_id = this.allFiles.map((x) => x.delete_id);
              vault_user_form_uploads_id = vault_user_form_uploads_id.concat(result.data.vault_user_form_uploads_id);
            } catch (error) {}

            if (result?.data.status == 'success') {
              this.dialogRef.close({
                isSuccess: true,
                files: this.allFiles,
                vault_user_form_uploads_id: vault_user_form_uploads_id,
                isRefresh: true,
                mark_complete: this.myForm.value.name,
              });
            }
          },
          (error: any) => {}
        )
      );
    }
  }
  savedialog() {
    if (this.openInboxFiles) {
      let attachmentIds: number[] = this.inboxAttachmentList.inboxFiles.filter((x) => x.selected).map((item) => item.id);

      if (attachmentIds.length == 0) {
        this.dialogRef.close({
          isSuccess: true,
          files: this.allFiles,
          mark_complete: this.myForm.value.name,
          nothingChange: attachmentIds.length == 0 && this.allFiles.length == 0 ? true : false,
        });
      } else {
        this.saveInboxAttachment(attachmentIds);
      }
    } else if (this.openMobileDeliveryLink) {
      if (this.openMobileDeliveryFile) {
        let attachmentIds: number[] = this.mobileDeliveryListFile.fileList.filter((x) => x.checked).map((x) => x.id);
        if (attachmentIds.length == 0) {
          this.dialogRef.close({
            isSuccess: true,
            mark_complete: this.myForm.value.name,
            files: this.allFiles,
            nothingChange: attachmentIds.length == 0 && this.allFiles.length == 0 ? true : false,
          });
        } else {
          this.saveInboxAttachment(attachmentIds);
        }

        return;
      }
      this.openMobileDeliveryFile = true;
    } else {
      if (this.files.findIndex((x) => x.status == 'Uploading') == -1) {
        this.dialogRef.close({
          isSuccess: false,
          mark_complete: this.myForm.value.name,
          files: this.allFiles,
          nothingChange: this.allFiles.length == 0 ? true : false,
          isRefresh: true,
          vault_user_form_uploads_id: this.allFiles.map((x) => x.delete_id),
        });
      }
    }
  }
  closedialog() {
    if (this.allFiles.length == 0 && !this.inboxFileAttached) {
      this.dialogRef.close({
        isSuccess: false,
        files: this.allFiles,
        mark_complete: this.myForm.value.name,
        nothingChange: true,
      });
    } else {
      this.dialogRef.close({
        isSuccess: false,
        files: this.allFiles,
        nothingChange: false,
        mark_complete: this.myForm.value.name,
        vault_user_form_uploads_id: this.allFiles.map((x) => x.delete_id),
        isRefresh: true,
      });
    }
  }

  allowDrop(ev) {
    this.active = true;
    ev.preventDefault();
  }
}
